import React, { useLayoutEffect, useRef } from 'react'
import { Textarea } from '@chakra-ui/react'

function useAutoResizeTextarea(value: string) {
  const ref = useRef<HTMLTextAreaElement>(null)

  useLayoutEffect(() => {
    if (!ref.current) return

    // Reset height so scrollHeight is correct
    ref.current.style.height = 'auto'
    ref.current.style.height = `${ref.current.scrollHeight}px`
  }, [value])

  return ref
}

type AutoTextareaProps = {
  value: string
  onChange: (v: string) => void
}

export function AutoResizeTextarea({
 value,
 onChange,
}: AutoTextareaProps) {
  const ref = useAutoResizeTextarea(value)

  return (
    <Textarea
      ref={ref}
      value={value}
      resize="none"
      overflow="hidden"
      rows={1}
      onChange={(e) => onChange(e.target.value)}
    />
)}
